import { FormControlLabel } from "@material-ui/core";
import FormControl from "@material-ui/core/FormGroup";
import Radio, { RadioProps } from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import HelpIcon from "@material-ui/icons/Help";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import ThumbDownIcon from "@material-ui/icons/ThumbDown";
import ThumbDownOutlinedIcon from "@material-ui/icons/ThumbDownOutlined";
import ThumbsUpDownIcon from "@material-ui/icons/ThumbsUpDown";
import ThumbsUpDownOutlinedIcon from "@material-ui/icons/ThumbsUpDownOutlined";
import ThumbUpIcon from "@material-ui/icons/ThumbUp";
import ThumbUpOutlinedIcon from "@material-ui/icons/ThumbUpOutlined";
import React from "react";
import TestCaseRating, { RATING_DICTIONARY } from "../../../../models/TestCaseRating.model";

const TestCasePassedRadio: React.FC<RadioProps> = (props) => (
  <Radio checkedIcon={<ThumbUpIcon />} disableRipple icon={<ThumbUpOutlinedIcon />} {...props} />
);
const TestCaseFailedRadio: React.FC<RadioProps> = (props) => (
  <Radio checkedIcon={<ThumbDownIcon />} disableRipple icon={<ThumbDownOutlinedIcon />} {...props} />
);
const TestCasePartiallyPassedRadio: React.FC<RadioProps> = (props) => (
  <Radio checkedIcon={<ThumbsUpDownIcon />} disableRipple icon={<ThumbsUpDownOutlinedIcon />} {...props} />
);
const TestCaseUnratedRadio: React.FC<RadioProps> = (props) => (
  <Radio checkedIcon={<HelpIcon />} disableRipple icon={<HelpOutlineIcon />} {...props} />
);
const RADIO_BY_RATING: { [R in TestCaseRating]: React.ReactElement } = {
  NOT_RATED: <TestCaseUnratedRadio />,
  PARTIALLY_PASSED: <TestCasePartiallyPassedRadio />,
  FAILED: <TestCaseFailedRadio />,
  PASSED: <TestCasePassedRadio />,
};

interface TestCaseRatingRadioGroupProps {
  disabled?: boolean;
  onChange: (newRating: TestCaseRating) => void;
  value: TestCaseRating | null;
}

const TestCaseRatingRadioGroup: React.FC<TestCaseRatingRadioGroupProps> = ({ disabled, onChange, value }) => {
  const handleRadioChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value as TestCaseRating);
  };

  return (
    <FormControl>
      <RadioGroup onChange={handleRadioChange} value={value} row>
        {Object.keys(RADIO_BY_RATING).map((rating) => (
          <FormControlLabel
            disabled={disabled}
            key={rating}
            value={rating}
            control={RADIO_BY_RATING[rating as TestCaseRating]}
            label={RATING_DICTIONARY[rating as TestCaseRating]}
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
};

export default TestCaseRatingRadioGroup;
